// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=checkbox][data-v-5ded3eb0]{height:1.5rem;width:1.5rem}label[data-v-5ded3eb0]{display:inline}", ""]);
// Exports
module.exports = exports;
